export enum EArchiveRoutes {
  ARCHIVE = 'Archive'
}
